import loadable from '@loadable/component';

export const MyvouchercodesSiteWrapper = loadable(
  () => import(/* webpackChunkName: "myvouchercodes-site" */ './MyvouchercodesSiteWrapper'),
);
